import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQualtricsComponent } from './simple-icons-qualtrics.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQualtricsComponent ],
    exports:      [ SimpleIconsQualtricsComponent ],
    bootstrap:    []
})
export class SimpleIconsQualtricsModule {}
